import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { withTheme } from 'emotion-theming'
import { array } from 'prop-types'

// Import Components
import CardLongSimple from 'components/CardLongSimple'
import { Link } from '@jelly/ui'

// styled components
const ReviewsWrapper = styled.div`
	height: 100%;
	max-width: 100%;
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	min-height: 600px;
	overflow: hidden;
	text-align: center;
	background-color: ${({ theme }) => theme.colors.lightGrey};
`
const Title = styled.div`
	font-size: 21px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.navy};
	margin-top: 30px;
	margin-bottom: 5px;
	${({ theme }) => theme.MQ.M} {
		font-size: 34px;
		font-weight: 500;
	}
`

// prettier-ignore
// because it's messing up the format of -ms-grid-* stuff below
const specialIEGridStyles = css`
	/* FOR IE11*/
	display: -ms-grid;
	-ms-grid-columns: (1fr)[2];
	-ms-grid-rows: (1fr)[3];
`

const ReviewCardsWrapper = styled.div`
	display: grid;
	text-align: center;
	grid-template-columns: 1fr;
	grid-template-rows: 3fr;
	width: 100%;
	position: relative;
	margin: auto;
	padding: 20px 0 0 0;

	a:nth-of-type(1) {
		background-color: ${({ theme }) => theme.colors.navy};
	}

	a:nth-of-type(2) {
		background-color: ${({ theme }) => theme.colors.lightBlue};
	}

	a:nth-of-type(3) {
		background-color: ${({ theme }) => theme.colors.navy};
	}

	a:nth-of-type(n + 4) {
		display: none;
	}
	/* FOR IE11*/
	display: -ms-grid;
	-ms-grid-columns: [1];
	-ms-grid-rows: [3];

	${({ theme }) => theme.MQ.M} {
		display: grid;
		grid-template-rows: repeat(3, 1fr);
		grid-template-columns: repeat(2, 1fr);

		a:nth-of-type(1) {
			background: ${({ theme }) => theme.colors.navy};
		}
		a:nth-of-type(2) {
			background: ${({ theme }) => theme.colors.lightBlue};
		}
		a:nth-of-type(3) {
			background: ${({ theme }) => theme.colors.lightBlue};
		}
		a:nth-of-type(4) {
			background: ${({ theme }) => theme.colors.navy};
		}
		a:nth-of-type(5) {
			background: ${({ theme }) => theme.colors.navy};
		}
		a:nth-of-type(6) {
			background: ${({ theme }) => theme.colors.lightBlue};
		}
		a:nth-of-type(n) {
			display: block;
		}
		width: 86.5%;

		/* FOR IE11*/
		${specialIEGridStyles}
	}
	${({ theme }) => theme.MQ.MAX} {
		width: 77.5%;
	}
`
const CategoriesButton = styled(Link)`
	${({ theme }) => theme.buttons.default};
	margin: auto;
	margin-top: 30px;
	margin-bottom: 30px;
`

ReviewCards.propTypes = { reviews: array.isRequired }

/**
 * This is the Review cards component for the review landing page
 * Contains long content cards for 6 most recent bestpicks
 */
function ReviewCards({ reviews }) {
	return (
		<ReviewsWrapper>
			<Title>Read our latest reviews.</Title>
			<ReviewCardsWrapper>
				{reviews.map((review, i) => {
					// this is to support css grid in IE11, set the styles here to keep the card components clean
					const gridBrowserSupport =
						i === 0
							? '-ms-grid-column: 1; -ms-grid-row: 1'
							: i === 1
							? '-ms-grid-column: 2; -ms-grid-row: 1'
							: i === 2
							? '-ms-grid-column: 1; -ms-grid-row: 2'
							: i === 3
							? '-ms-grid-column: 2; -ms-grid-row: 2'
							: i === 4
							? '-ms-grid-column: 1; -ms-grid-row: 3'
							: '-ms-grid-column: 2; -ms-grid-row: 3'
					return (
						<CardLongSimple
							gridBrowserSupport={gridBrowserSupport}
							title={review.subtitle}
							description={review.cardDescription}
							url={review.canonical}
							key={i}
						/>
					)
				})}
			</ReviewCardsWrapper>
			<CategoriesButton href="/buying-guides/">SEE ALL CATEGORIES</CategoriesButton>
		</ReviewsWrapper>
	)
}
export default withTheme(ReviewCards)
